"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SamplesAndExceedencesCard = void 0;
var React = require("react");
var getPercentage_1 = require("../../utils/getPercentage");
var __1 = require("../..");
var styled_1 = require("../../styled");
var defaultStyle = {};
var SamplesAndExceedencesCard = /** @class */ (function (_super) {
    __extends(SamplesAndExceedencesCard, _super);
    function SamplesAndExceedencesCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SamplesAndExceedencesCard.prototype.render = function () {
        var _a = this.props, completed = _a.completed, exceedances = _a.exceedances, total = _a.total, _b = _a.style, style = _b === void 0 ? defaultStyle : _b;
        return (React.createElement(StatsCard, { style: style },
            React.createElement("div", null,
                React.createElement(CardHeading, null, this.labelText('samplesTitle')),
                React.createElement(__1.ProgressBar, { variant: "success", width: 7, percent: getPercentage_1.getPercentage({
                        value: completed,
                        max: total,
                    }) }),
                React.createElement(StatsLabel, null, this.labelText('samplesSubtitle'))),
            React.createElement("div", null,
                React.createElement(CardHeading, null, this.labelText('exceedancesTitle')),
                React.createElement(__1.ProgressBar, { variant: "error", width: 7, percent: getPercentage_1.getPercentage({
                        value: exceedances,
                        max: total,
                    }) }),
                React.createElement(StatsLabel, null, this.labelText('exceedancesSubtitle')))));
    };
    SamplesAndExceedencesCard.prototype.labelText = function (section) {
        switch (section) {
            case 'samplesTitle':
                return this.sampleTitle();
            case 'samplesSubtitle':
                return this.samplesSubtitle();
            case 'exceedancesTitle':
                return this.exceedancesTitle();
            case 'exceedancesSubtitle':
                return this.exceedancesSubtitle();
            default:
                return '';
        }
    };
    SamplesAndExceedencesCard.prototype.sampleTitle = function () {
        var completed = this.props.completed;
        var extension = 'Completed Sample';
        if (completed !== 1) {
            extension += 's';
        }
        return completed + " " + extension;
    };
    SamplesAndExceedencesCard.prototype.samplesSubtitle = function () {
        var _a = this.props, completed = _a.completed, total = _a.total;
        var extension = "of " + total + " Ordered Sample";
        if (total !== 1) {
            extension += 's';
        }
        return completed + " " + extension;
    };
    SamplesAndExceedencesCard.prototype.exceedancesTitle = function () {
        var exceedances = this.props.exceedances;
        var extension = "Exceedance";
        if (exceedances !== 1) {
            extension += 's';
        }
        return exceedances + " " + extension;
    };
    SamplesAndExceedencesCard.prototype.exceedancesSubtitle = function () {
        var _a = this.props, completed = _a.completed, exceedances = _a.exceedances;
        var extension = "of " + completed + " Completed Sample";
        if (completed !== 1) {
            extension += 's';
        }
        return exceedances + " " + extension;
    };
    return SamplesAndExceedencesCard;
}(React.Component));
exports.SamplesAndExceedencesCard = SamplesAndExceedencesCard;
var Card = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  border-radius: 0.33rem;\n  margin-bottom: 2rem;\n  padding: 2rem;\n"], ["\n  background: ", ";\n  border-radius: 0.33rem;\n  margin-bottom: 2rem;\n  padding: 2rem;\n"])), __1.colors.white);
var CardHeading = styled_1.default.h6(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-weight: bold;\n  margin-bottom: 1.33rem;\n  margin-top: 1.33rem;\n"], ["\n  font-weight: bold;\n  margin-bottom: 1.33rem;\n  margin-top: 1.33rem;\n"])));
var StatsCard = styled_1.default(Card)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n\n  & div:first-of-type {\n    margin-right: 2rem;\n  }\n\n  & > div {\n    width: 50%;\n  }\n"], ["\n  display: flex;\n\n  & div:first-of-type {\n    margin-right: 2rem;\n  }\n\n  & > div {\n    width: 50%;\n  }\n"])));
var StatsLabel = styled_1.default.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 1.1667rem;\n  font-weight: 300;\n"], ["\n  font-size: 1.1667rem;\n  font-weight: 300;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map